"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file generate metadata for a link
 */
const filesize_1 = __importDefault(require("filesize"));
const link_helpers_1 = require("./link_helpers");
function makeMetadata(link) {
  const meta = {};
  if ((0, link_helpers_1.isFile)(link)) {
    const size = link.size;
    const prettySize = (0, filesize_1.default)(size || 0, {
      round: 0
    });
    meta.pretty_size = prettySize;
    return {
      ...link.metadata,
      ...meta
    };
  }
  return link.metadata;
}
exports.default = makeMetadata;